/**
 * 語言標籤
 */
export const LANGUAGE_LABEL = {
    "zh-TW": "繁中（zh-TW）",
    taiwanese: "中文（臺語）（taiwanese）",
    "zh-CN": "中文（簡體）（zh-CN）",
    "zh-HK": "中文（香港）（zh-HK）",
    "en-US": "英文（美式）（en-US）",
    "en-GB": "英文（英式）（en-GB）",
    "ja-JP": "日文（ja-JP）",
    "ko-KR": "韓文（ko-KR）",
    "fr-FR": "法文（fr-FR）",
    "es-ES": "西班牙文（es-ES）",
    "ca-ES": "加泰隆尼亞文（ca-ES）",
    "vi-VN": "越南文（vi-VN）",
    "th-TH": "泰文（th-TH）",
    "id-ID": "印尼文（id-ID）",
    "km-KH": "高棉文（km-KH）",
    "ro-RO": "羅馬尼亞文（ro-RO）",
    "ru-RU": "俄文（ru-RU）",
    "pt-PT": "葡萄牙文（pt-PT）",
    "ta-MY": "坦米爾文（ta-MY）",
    "hi-IN": "印地文（hi-IN）",
    "ar-EG": "阿拉伯文（ar-EG）",
    ar: "阿拉伯文（ar）",
    "it-IT": "義大利文（it-IT）",
    "de-DE": "德文（de-DE）",
    "ms-MY": "馬來文（ms-MY）",
};

/**
 * 節慶排程
 */
export const FESTIVAL_SCHEDULE = [
    {
        year: 2024,
        name: "跨年",
        key: "NewYear",
        startDate: "2023/12/28",
        endDate: "2024/1/5",
        description: "跨年與元旦檔期",
    },
    {
        year: 2024,
        name: "春節",
        key: "CNY",
        startDate: "2024/1/15",
        endDate: "2024/2/29",
        description: "春節與元宵節活動",
    },
    {
        year: 2024,
        name: "端午",
        key: "DragonBoat",
        startDate: "2024/5/15",
        endDate: "2024/6/23",
        description: "端午節活動（龍舟/ 粽子主題）",
    },
    {
        year: 2024,
        name: "中秋",
        key: "Moon",
        startDate: "2024/8/30",
        endDate: "2024/9/22",
        description: "中秋節活動（月餅/賞月主題）",
    },
    {
        year: 2024,
        name: "聖誕節",
        key: "Christmas",
        startDate: "2024/12/2",
        endDate: "2024/12/25",
        description: "年底聖誕節活動",
    },
    {
        year: 2025,
        name: "春節",
        key: "CNY",
        startDate: "2024/12/26",
        endDate: "2025/2/12",
        description: "跨年後接續春節檔期",
    },
    {
        year: 2025,
        name: "端午",
        key: "DragonBoat",
        startDate: "2025/5/26",
        endDate: "2025/6/6",
        description: "端午節活動（龍舟/ 粽子主題）",
    },
    {
        year: 2025,
        name: "中秋",
        key: "Moon",
        startDate: "2025/9/8",
        endDate: "2025/10/6",
        description: "中秋節活動（月餅/賞月主題）",
    },
];
